import { ApiClientError } from '../api/httpClient';

export type FormErrors = Record<string, string[]>;

export function addFormError(errors: FormErrors, fieldName: string, message: string): void {
  const fieldErrors = errors[fieldName] ?? [];

  errors[fieldName] = [...fieldErrors, message];
}

export function getFieldError(errors: FormErrors, fieldName: string): string | null {
  return errors[fieldName]?.[0] ?? null;
}

export function clearFormFieldError(errors: FormErrors, fieldName: string): FormErrors {
  const nextErrors = { ...errors };

  delete nextErrors[fieldName];

  return nextErrors;
}

export function getFormErrorMessages(errors: FormErrors): string[] {
  return Array.from(new Set(Object.values(errors).flat()));
}

export function hasFormErrors(errors: FormErrors): boolean {
  return Object.keys(errors).length > 0;
}

export function formErrorsFromApiError(error: unknown): FormErrors {
  if (!(error instanceof ApiClientError)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(error.errors).filter((entry): entry is [string, string[]] => {
      const [, messages] = entry;

      return Array.isArray(messages) && messages.length > 0;
    }),
  );
}

export function validateEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function validateDigits(value: string, allowedLengths: number[]): boolean {
  const normalizedValue = value.trim();

  return /^\d+$/.test(normalizedValue) && allowedLengths.includes(normalizedValue.length);
}
